export const FETCH_AMALGAMATED_HROMADA = "FETCH_AMALGAMATED_HROMADA"
export const CREATE_AMALGAMATED_HROMADA = "CREATE_AMALGAMATED_HROMADA"
export const UPDATE_AMALGAMATED_HROMADA = "UPDATE_AMALGAMATED_HROMADA"
export const DELETE_AMALGAMATED_HROMADA = "DELETE_AMALGAMATED_HROMADA"
